export default function addHighlightedAttribute({ item, query, props = ['label', 'shortDescription'] }) {
    const highlightedResults = {}
    for (const prop of props) {
        const value = item[prop]
        if (typeof value === 'string') {
            highlightedResults[prop] = {
                value: query
                    ? `${value}`.replace(
                          new RegExp(query.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'),
                          (match) => `__aa-highlight__${match}__/aa-highlight__`
                      )
                    : value,
            }
        } else {
            highlightedResults[prop] = {
                value: '',
            }
        }
    }

    return {
        ...item,
        _highlightResult: highlightedResults,
    }
}
